var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackagedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9602C389-301B-4BFF-B1F4-F94A2B77F4EB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-history-view",
    transform: "translate(-776, -701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(500, 657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-3",
    transform: "translate(265, 35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "packaged-icon",
    transform: "translate(11, 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,19.425 L11,12.575 L5,9.1 L5,15.95 L11,19.425 Z M13,19.425 L19,15.95 L19,9.1 L13,12.575 L13,19.425 Z M12,10.85 L17.925,7.425 L12,4 L6.075,7.425 L12,10.85 Z M4,17.7 C3.68333,17.5167 3.4375,17.275 3.2625,16.975 C3.0875,16.675 3,16.3417 3,15.975 L3,8.025 C3,7.65833 3.0875,7.325 3.2625,7.025 C3.4375,6.725 3.68333,6.48333 4,6.3 L11,2.275 C11.3167,2.09167 11.65,2 12,2 C12.35,2 12.6833,2.09167 13,2.275 L20,6.3 C20.3167,6.48333 20.5625,6.725 20.7375,7.025 C20.9125,7.325 21,7.65833 21,8.025 L21,15.975 C21,16.3417 20.9125,16.675 20.7375,16.975 C20.5625,17.275 20.3167,17.5167 20,17.7 L13,21.725 C12.6833,21.9083 12.35,22 12,22 C11.65,22 11.3167,21.9083 11,21.725 L4,17.7 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagedIcon);
export default __webpack_public_path__ + "static/media/packaged-icon.6755a94be9b4ee40c50f05316ce197c3.svg";
export { ForwardRef as ReactComponent };